
// export const logout = ( state ) => {
// }

export const setUsers = (state, users) => {
    state.users = users
}

export const setUsersSelectable = (state, users) => {
    state.usersSelectable = users
}

export const setUsersPaginated = (state, usersPaginatedData) => {
    state.usersPaginatedData = usersPaginatedData
}

export const setUserDetail = (state, user) => {
    state.state = user
}

export const saveNewUsers = (state, user) => {
    state.users.unshift(user)
    state.createdData = user;
}

export const setUserExist = (state, user) => {
    state.foundData = user;
}

export const saveUpdatedUser = (state, user) => {
    state.users.unshift(user)
    state.updatedData = user;
}

export const setDeleteUser = (state, user) => {
    state.deletedData = user
}

export const setUserIsLoading = (state, isLoading) => {
    state.isLoading = isLoading
}

export const setUserIsFinding = (state, isFinding) => {
    state.isFinding = isFinding
}

export const setUserIsCreating = (state, isCreating) => {
    state.isCreating = isCreating
}

export const setUserIsUpdating = (state, isUpdating) => {
    state.isUpdating = isUpdating
}

export const setUserIsDeleting = (state, isDeleting) => {
    state.isDeleting = isDeleting
}
